import React from "react";
import { Route, Routes } from "react-router-dom";
import { notification } from "antd";
import { IClient, useClient } from "../../Context/ClientContext";
import { NotificationPlacement } from "antd/es/notification/interface";
import DashboardTemplate from "../../Template/DashboardTemplate";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import ShareCapitalNestedRoute from "../../Pages/Share Capital/ShareCapitalNestedRoute";
import { Registers } from "../../Pages/Reports/Registers/Register";
import SettingNestedRoute from "../../Pages/Settings/NestedRoute/SettingNestedRoute";
import EditInvoiceTemplate from "../../Pages/Settings/Template/EditInvoiceTemplate";
import DraftTable from "../../Pages/Draft/DraftTable";
import NewDashboard from "../../Pages/MainDashboard/NewDashboard";
import ResourceNotFound from "../ResourceNotFound";
import { useUser } from "../../../Context/UserContext";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Pages/Users/Roles/UserSecurityFind";
import RoleTable from "../../Pages/Users/Roles/RolesTable";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import OrganisationNestedRoute from "../../Pages/Organisations/OrganisationNestedRoute";
import ItemRoutes from "./ItemRoute";
import ExpensesAndIncomeRoute from "./ExpensesAndIncomeRoute";
import AssetsRoute from "./AssetsRoute";
import PartiesRoute from "./PartiesRoute";
import SalesRoute from "./SalesRoute";
import PurchaseRoute from "./PurchaseRoute";
import MasterRoutes from "./MasterRoutes";
import JournalRoute from "./JournalRoute";
import CashAndBankRoute from "./CashAndBankRoute";
import ReportRoute from "./ReportRoute";
// import BankTransactionsTab from "../Pages/Banking/Banks/BankTransactionsTab";

export interface ItemRoutesProps {
  currentClient: IClient | undefined;
  clientSpecificRole: () => boolean | undefined;
}

// ---------- React.lazy ----------

// const AsyncSalesInvoiceTemplate = React.lazy(
//   () => import("../Template/SalesInvoiceTemplate")
// );
// const AsyncDashboardTemplate = React.lazy(
//   () => import("../Template/DashboardTemplate")
// );
// const AsyncAddSalesCreditNotes = React.lazy(
//   () => import("../Pages/Sales/AddSalesCreditNotesNew")
// );
// const AsyncSalesOrders = React.lazy(
//   () => import("../Pages/Sales/AddSalesOrder")
// );
// const AsyncAddSalesInvoice = React.lazy(
//   () => import("../Pages/Sales/AddSalesInvoiceAndPurchaseBill")
// );
// const AsyncAddQuotation = React.lazy(
//   () => import("../Pages/Sales/AddQuotation")
// );
// const AsyncSalesNestedRoute = React.lazy(
//   () => import("../Pages/Sales/SalesNestedRoute")
// );
// const AsyncAddPaymentIn = React.lazy(
//   () => import("../Pages/Sales/AddPaymentIn")
// );
// const AsyncShareCapitalNestedRoute = React.lazy(
//   () => import("../Pages/Share Capital/ShareCapitalNestedRoute")
// );
// const AsyncJournals = React.lazy(
//   () => import("../Pages/Journals/JournalsTable")
// );
// const AsyncAddJournal = React.lazy(
//   () => import("../Pages/Journals/AddJournal")
// );
// const AsyncAssetsNestedRoute = React.lazy(
//   () => import("../Pages/Assets/AssetsNestedRoute")
// );
// const AsyncPurchaseNestedRoute = React.lazy(
//   () => import("../Pages/Purchase/PurchaseNestedRoute")
// );
// const AsyncAddPurchaseInvoice = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseInvoice")
// );
// const AsyncAddPurchaseCreditNote = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseCreditNote")
// );
// const AsyncAddPurchaseOrder = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseOrder")
// );
// // const AsyncAddPurchasePayment = React.lazy(
// //   () => import("../Pages/Purchase/AddPurchasePayment")
// // );
// const AsyncAddPayment = React.lazy(
//   () => import("../Pages/Purchase/AddPaymentOut")
// );
// const AsyncLedger = React.lazy(() => import("../Pages/Ledger/Ledger"));
// const AsyncTrialBalance = React.lazy(
//   () => import("../Pages/TrialBalance/TrialBalance")
// );
// const AsyncSettings = React.lazy(() => import("../Pages/Settings/Settings"));
// const AsyncChartOfAccounts = React.lazy(
//   () => import("../Pages/ChartOfAccounts/ChartOfAccounts")
// );
// const AsyncAgeing = React.lazy(() => import("../Pages/Ageing/Ageing"));
// const AsyncBalanceSheet = React.lazy(
//   () => import("../Pages/BalanceSheet/BalanceSheet")
// );
// const AsyncProfitAndLoss = React.lazy(
//   () => import("../Pages/ProfitAndLoss/ProfitAndLoss")
// );
// const AsyncParties = React.lazy(() => import("../Pages/Parties/Party"));

// // const AsyncIncomeIncome = React.lazy(
// //   () => import("../Pages/Expenses&income/ExpensesIncomeNestedRoute")
// // );
// const AsyncExpensesIncomeNestedRoute = React.lazy(
//   () => import("../Pages/Expenses&income/ExpensesIncomeNestedRoute")
// );
// const AsyncAddExpensesInvoice = React.lazy(
//   () => import("../Pages/Expenses&income/AddExpenses")
// );
// const AsyncAddIncomeInvoice = React.lazy(
//   () => import("../Pages/Expenses&income/AddIncome")
// );
// const AsyncAddCategory = React.lazy(
//   () => import("../Pages/Expenses&income/AddCategoryModel")
// );

// const AsyncBankRules = React.lazy(() => import("../Pages/BackRules/BankRules"));
// const AsyncGstReturn = React.lazy(() => import("../Pages/GstReturn/GstReturn"));
// const AsyncOpeningBalance = React.lazy(
//   () => import("../Pages/OpeningBalance/OpeningBalance")
// );

// // const AsyncMainDashboard = React.lazy(
// //   () => import("../Pages/MainDashboard/MainDashboard")
// // );

export type NotificationType = "success" | "info" | "warning" | "error";

export enum ISilderName {
  Dashboard,
  Party,
  Item,
  Sales,
  Purchase,
  Expenses,
  Journals,
  Banking,
  FixedAsset,
  Draft,
  Registers,
  Master,
  Settings,
  ShareCapital,
  Organisations,
}

export const notificationContext = React.createContext<any>({});

const PageRoute = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  // const useAccessSettingsData: IAccessSettings = accessSettings();
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: NotificationType,
    message: string,
    description?: string,
    duration?: number,
    closeIcon?: boolean,
    placement?: NotificationPlacement,
    icon?: any
  ) => {
    api[type]({
      message: message,
      description: description,
      duration: duration ? duration : 4,
      // closeIcon: closeIcon ? false : <CloseOutlined  />,
      // style: {
      //   marginTop: "23px",
      //   padding: "15px 12px 7px 15px",
      // },
      placement: placement,
      icon: icon,
    });
  };

  return (
    <notificationContext.Provider value={{ openNotification }}>
      <>
        {/* <React.Suspense fallback={<FullPageSpinner />}> */}
        <Routes>
          {/*  ----------- Dashboard Route -----------*/}
          <Route
            path={`${currentClient?.id}/dashboard`}
            element={
              <DashboardTemplate
                element={
                  findUserOnlyOnePremission(
                    "Dashboard.View",
                    clientSpecificRole(),
                    currentClient?.id!
                  ) ? (
                    <NewDashboard />
                  ) : (
                    <ResourceNotFound pageHeight="100%" />
                  )
                }
                breadcrumprops={[
                  {
                    item: "DashBoard",
                  },
                ]}
              />
            }
          />
          {/* ----------- Parties Route ----------- */}
          {PartiesRoute({ currentClient, clientSpecificRole })}
          {/* ----------- Item Route ----------- */}
          {ItemRoutes({ currentClient, clientSpecificRole })}
          {/*----------- Sales Route -----------*/}
          {SalesRoute({ currentClient, clientSpecificRole })}
          {/* ----------- Purchase Route ----------- */}
          {PurchaseRoute({ currentClient, clientSpecificRole })}
          {/* ----------- Expenses And IncomeRoute ----------- */}
          {ExpensesAndIncomeRoute({ currentClient, clientSpecificRole })}
          {/*----------- Journal Route ----------- */}
          {JournalRoute({ currentClient, clientSpecificRole })}
          {/*  ----------- Cash & Bank Route -----------  */}
          {CashAndBankRoute({ currentClient, clientSpecificRole })}
          {/* ----------- Assets Route ----------- */}
          {AssetsRoute({ currentClient, clientSpecificRole })}
          {/* ----------- Draft Route----------- */}
          <Route
            path={`${currentClient?.id}/draft/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Sales.1.View",
                  "Voucher.Sales.2.View",
                  "Voucher.Sales.3.View",
                  "Voucher.Sales.5.View",
                  "Voucher.Sales.4.View",
                  "Voucher.Sales.6.View",

                  "Voucher.Purchase.7.View",
                  "Voucher.Purchase.8.View",
                  "Voucher.Purchase.10.View",
                  "Voucher.Purchase.9.View",

                  "Voucher.Expenses.14.View",
                  "Voucher.Income.15.View",

                  "Voucher.Journal.12.View",

                  "Voucher.Contra.13.View",

                  "Voucher.Asset.11.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,

                  // Purchase
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,

                  // expenses & income
                  SettingsSections.Expenses,
                  SettingsSections.Income,

                  // Journal
                  SettingsSections.Journal,
                  // Contra
                  SettingsSections.Contra,
                  // Asset
                  SettingsSections.Asset,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<DraftTable />}
                  breadcrumprops={[
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Registers Route ----------- */}
          <Route
            path={`/${currentClient?.id}/registers/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Sales.1.View",
                  "Voucher.Sales.2.View",
                  "Voucher.Sales.3.View",
                  "Voucher.Sales.5.View",
                  "Voucher.Sales.4.View",
                  "Voucher.Sales.6.View",

                  "Voucher.Purchase.7.View",
                  "Voucher.Purchase.8.View",
                  "Voucher.Purchase.10.View",
                  "Voucher.Purchase.9.View",

                  "Voucher.Expenses.14.View",
                  "Voucher.Income.15.View",

                  "Voucher.Journal.12.View",

                  "Voucher.Contra.13.View",

                  "Voucher.Asset.11.View",
                ],
                clientSpecificRole(),
                currentClient?.id!,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,

                  // Purchase
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,

                  // expenses & income
                  SettingsSections.Expenses,
                  SettingsSections.Income,

                  // Journal
                  SettingsSections.Journal,
                  // Contra
                  SettingsSections.Contra,
                  // Asset
                  SettingsSections.Asset,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<Registers />}
                  breadcrumprops={[
                    {
                      item: "Registers",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/*----------- Reports Route -----------*/}
          {ReportRoute({ currentClient, clientSpecificRole })}

          {/* ----------- Master Route ----------- */}
          {MasterRoutes({ currentClient, clientSpecificRole })}

          {/* ----------- Settings Route ----------- */}
          <Route
            path={`/${currentClient?.id}/settings/*`}
            element={
              findUserPremission(
                [
                  "Setting.Company.Info.View",
                  "Setting.Company.Details.View",
                  "Setting.Company.PaymentTerm.View",
                  "Setting.Company.GST.View",

                  "Setting.Voucher.1.View",
                  "Setting.Voucher.2.View",
                  "Setting.Voucher.3.View",
                  "Setting.Voucher.5.View",
                  "Setting.Voucher.4.View",
                  "Setting.Voucher.6.View",

                  "Setting.Voucher.7.View",
                  "Setting.Voucher.8.View",
                  "Setting.Voucher.10.View",
                  "Setting.Voucher.9.View",

                  "Setting.Voucher.14.View",
                  "Setting.Voucher.15.View",

                  "Setting.Voucher.13.View",
                  "Setting.Voucher.12.View",
                  "Setting.Voucher.11.View",

                  "Setting.Item.View",
                  "Setting.OpeningBalance.View",
                  "Setting.Templates.View",
                  "Setting.DefaultLedger.View",

                  "Setting.TC.1.View",
                  "Setting.TC.2.View",
                  "Setting.TC.3.View",
                  "Setting.TC.5.View",
                  "Setting.TC.4.View",
                  "Setting.TC.6.View",
                  "Setting.TC.7.View",
                  "Setting.TC.8.View",
                  "Setting.TC.10.View",
                  "Setting.TC.9.View",
                  "Setting.TC.14.View",
                  "Setting.TC.15.View",
                  "Setting.TC.13.View",
                  "Setting.TC.12.View",
                  "Setting.TC.11.View",

                  "Setting.TDS.View",
                  "Setting.TCS.View",

                  "Setting.Currencies.View",
                ],
                clientSpecificRole(),
                currentClient?.id!,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,

                  // Purchase
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,

                  // expenses & income
                  SettingsSections.Expenses,
                  SettingsSections.Income,

                  // Journal
                  SettingsSections.Journal,
                  // Contra
                  SettingsSections.Contra,
                  // Asset
                  SettingsSections.Asset,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [
                    ITypeIIsClientSpecificRoleDataType.Setting,
                    ITypeIIsClientSpecificRoleDataType.TandC,
                  ],
                }
              ) ? (
                <SalesInvoiceTemplate
                  silderName={ISilderName.Settings}
                  element={<SettingNestedRoute />}
                  breadcrumprops={[
                    {
                      item: "Company Settings",
                      path: `/books/clients/${currentClient?.id}/settings/companyInfo`,
                    },
                  ]}
                  menuprops={[
                    { showData: "Company Info" },
                    { showData: "Vouchers" },
                    { showData: "Items" },
                    // { showData: "Payment Term" },
                    // { showData: "GST" },
                    // { showData: "Report" },
                    { showData: "Opening Balance" },
                    { showData: "Closing Entries" },
                    // { showData: "Email" },
                    { showData: "Templates" },
                    // { showData: "AdvSetting" },
                    { showData: "Default Ledger" },
                    { showData: "Terms And Conditions" },
                    { showData: "TDS" },
                    { showData: "TCS" },
                    { showData: "Currencies" },
                    { showData: "Lock Month" },
                    // { showData: "NewDashboard" },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Templetes Route ----------- */}
          <Route
            path={`${currentClient?.id}/settings/templates/:type`}
            element={
              findUserOnlyOnePremission(
                "Setting.Templates.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<EditInvoiceTemplate />}
                  breadcrumprops={[
                    {
                      item: "Company Settings",
                      path: `/books/clients/${currentClient?.id}/settings/companyInfo`,
                    },
                    {
                      item: "Templates",
                      path: `/books/clients/${currentClient?.id}/settings/templates`,
                    },
                    // {
                    //   item: `/:type`,
                    // },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* <Route
            path={`${currentClient?.id}/settings/templates/2`}
            element={
              <DashboardTemplate
                element={<EditInvoiceTemplate />}
                breadcrumprops={[
                  {
                    item: "Company Settings",
                    path: `/books/clients/${currentClient?.id}/settings/companyInfo`,
                  },
                ]}
              />
            }
          /> */}

          {/* ----------- Roles Route ----------- */}
          <Route
            path={`${currentClient?.id}/roles`}
            element={
              // findUserPremission(
              //   ["Master.Item.View"],
              //   clientSpecificRole(),
              //   currentClient?.id!
              // ) ? (
              <DashboardTemplate
                element={<RoleTable clientId={currentClient?.id!} />}
                breadcrumprops={[
                  {
                    item: "Item",
                    path: `/books/clients/${currentClient?.id}/item/items`,
                  },

                  {
                    item: "Items",
                  },
                ]}
              />
              // ) : (
              //   <ResourceNotFound pageHeight="100%" />
              // )
            }
          />
          {/* ----------- Organisations Route ----------- */}
          <Route
            key="organisations"
            path={`${currentClient?.id}/organisations/*`}
            element={
              <SalesInvoiceTemplate
                element={<OrganisationNestedRoute />}
                silderName={ISilderName.Organisations}
                breadcrumprops={[
                  {
                    item: "Organisations",
                    path: `/books/clients/${currentClient?.id}/organisations/organisations`,
                  },
                ]}
                menuprops={[
                  {
                    showData: "Organisations",
                  },
                  {
                    showData: "Sub Units",
                  },
                  {
                    showData: "Departments",
                  },
                  {
                    showData: "Designations",
                  },
                  {
                    showData: "Employees",
                  },
                ]}
              />
            }
          />

          {/* ----------- Share capital Route ----------- */}
          <Route
            key="sharecapital"
            path={`/${currentClient?.id}/sharecapital/*`}
            element={
              <SalesInvoiceTemplate
                silderName={ISilderName.ShareCapital}
                element={<ShareCapitalNestedRoute />}
                breadcrumprops={[
                  {
                    item: "Share Capital",
                    path: `/books/clients/${currentClient?.id}/sharecapital/sharecapital`,
                  },
                ]}
                menuprops={[
                  {
                    showData: "Share Capital",
                  },
                  {
                    showData: "Shareholders",
                  },

                  {
                    showData: "Dividents",
                  },
                ]}
              />
            }
          />

          {/* ----------- Opening Balance Route ----------- */}
          {/* <Route
            path={`/${currentClient?.id}/openingBalance/*`}
            element={
              <DashboardTemplate
                element={<OpeningBalance />}
                breadcrumprops={[
                  {
                    item: "Opening Balance",
                  },
                ]}
              />
            }
          /> */}

          {/* Inventory Route */}
          {/* <Route
            path={`${currentClient?.id}/master/items/inventory`}
            element={
              <DashboardTemplate
                element={<InventoryTabs />}
                breadcrumprops={[
                  {
                    item: "Master",
                    path: `/books/clients/${currentClient?.id}/master/ledger`,
                  },
                  {
                    item: "Items",
                    path: `/books/clients/${currentClient?.id}/master/items`,
                  },
                  {
                    item: "Goods",
                  },
                ]}
              />
            }
          /> */}

          {/* ----------- Page not found ----------- */}

          <Route
            path={`${currentClient?.id}/*`}
            element={<ResourceNotFound pageHeight="100%" />}
          />
        </Routes>
        {/* </React.Suspense> */}
        {contextHolder}
      </>
    </notificationContext.Provider>
  );
};
export default PageRoute;
